/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceQuerySortCriteria {
    getFixupPrototypeFunction() { return ResourceQuerySortCriteria.fixupPrototype; }

    static newInstance(model: Partial<ResourceQuerySortCriteria>): ResourceQuerySortCriteria {
        let obj = Object.assign(new ResourceQuerySortCriteria(), model);
        ResourceQuerySortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceQuerySortCriteria>): ResourceQuerySortCriteria {
        if (!model) return null;
        return ResourceQuerySortCriteria.newInstance(<ResourceQuerySortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceQuerySortCriteria) {
        if (!obj) return;

        models.ResourceQuerySortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceQuerySortCriteria): boolean {
        Object.setPrototypeOf(obj, ResourceQuerySortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.ResourceQuerySortColumn;

    ascending: boolean;

}
